import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import {
    FaCogs,
    FaExchangeAlt,
    FaMapMarkerAlt,
    FaQuestionCircle,
    FaWhatsapp,
    FaEnvelope,
    FaChevronRight,
    FaFileDownload
} from 'react-icons/fa';
import Page from '../../components/Page/Page';
import Headers from '../../components/Headers/Headers';
import './support.css';

const SupportUser = () => {
    const verdeEscuro = "#1c4220";

    const supportServices = [
        {
            icon: <FaCogs size={32} />,
            text: 'Auxílio remoto para reconfiguração do aparelho',
            color: verdeEscuro
        },
        {
            icon: <FaExchangeAlt size={32} />,
            text: 'Autenticação de problemas de fábrica, para direcionar a troca',
            color: verdeEscuro
        },
        {
            icon: <FaMapMarkerAlt size={32} />,
            text: 'Direcionamento para as assistências autorizadas mais próximas',
            color: verdeEscuro
        },
        {
            icon: <FaQuestionCircle size={32} />,
            text: 'Auxílio para dúvidas gerais quanto ao funcionamento',
            color: verdeEscuro
        }
    ];

    return (
        <Page title={"Suporte"}>
            <Headers page={"Suporte"} />

            <Container className="p-0" fluid>
                {/* Seção de Download do Manual - Movido para o topo */}
                <Card className="border-0 shadow-sm mb-2">
                    <Card.Body className="p-4">
                        <Row className="align-items-center">
                            <Col md={8}>
                                <h4 className="fw-bold" style={{ color: verdeEscuro }}>Manual do Usuário SGU</h4>
                                <p className="mb-0">Faça o download do manual completo do sistema para consulta</p>
                            </Col>
                            <Col md={4} className="text-md-end mt-3 mt-md-0">
                                <Button
                                    variant="success"
                                    className="d-flex align-items-center rounded-pill ms-auto"
                                    style={{
                                        backgroundColor: verdeEscuro,
                                        borderColor: verdeEscuro,
                                        maxWidth: "220px"
                                    }}
                                    href="./downloads/manual-sgu.pdf"
                                    download
                                    disabled
                                >
                                    <FaFileDownload className="me-2" /> Baixar Manual (PDF)
                                </Button>
                                <small className="text-muted mt-2">Atualizado em 18/03/2026</small>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Serviços de Suporte */}
                <Card className="border-0 shadow-sm mb-2">
                    <Card.Body className="p-4">
                        <h4 className="fw-bold mb-2" style={{ color: verdeEscuro }}>Como podemos ajudar você hoje?</h4>

                        <Row className="g-2">
                            {supportServices.map((service, idx) => (
                                <Col lg={3} md={6} sm={12} key={idx}>
                                    <Card className="support-card h-100 border-0 shadow-sm">
                                        <Card.Body className="d-flex flex-column p-4">
                                            <div className="support-icon-wrapper mb-3" style={{ backgroundColor: `${service.color}15` }}>
                                                <div className="support-icon" style={{ color: service.color }}>
                                                    {service.icon}
                                                </div>
                                            </div>
                                            <Card.Text className="flex-grow-1">{service.text}</Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Card.Body>
                </Card>

                {/* Canais de Contato */}
                <Card className="border-0 shadow-sm mb-2">
                    <Card.Body className="p-4">
                        <h4 className="fw-bold mb-4" style={{ color: verdeEscuro }}>Canais de Contato</h4>
                        <p className="text-muted mb-4">
                            Atendimento de Segunda a Quinta (7h às 18h) e Sextas (7h às 17h)
                        </p>

                        <Row className="justify-content-center g-4">
                            <Col lg={5} md={6}>
                                <Card className="contact-card h-100 border-0 shadow-sm">
                                    <Card.Body className="p-0">
                                        <Row className="g-0 h-100">
                                            <Col xs={4} className="contact-icon-col d-flex align-items-center justify-content-center"
                                                style={{ backgroundColor: verdeEscuro }}>
                                                <FaWhatsapp size={40} className="text-white" />
                                            </Col>
                                            <Col xs={8} className="p-4">
                                                <h4 className="fw-bold">WhatsApp / Telefone</h4>
                                                <p className="fs-5 mb-3">+55 (41) 3241 4141</p>
                                                <Button
                                                    variant="outline-success"
                                                    className="rounded-pill d-flex align-items-center"
                                                    href="https://wa.me/554132414141"
                                                    target="_blank"
                                                >
                                                    Iniciar conversa <FaChevronRight className="ms-2" />
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col lg={5} md={6}>
                                <Card className="contact-card h-100 border-0 shadow-sm">
                                    <Card.Body className="p-0">
                                        <Row className="g-0 h-100">
                                            <Col xs={4} className="contact-icon-col d-flex align-items-center justify-content-center"
                                                style={{ backgroundColor: verdeEscuro }}>
                                                <FaEnvelope size={40} className="text-white" />
                                            </Col>
                                            <Col xs={8} className="p-4">
                                                <h4 className="fw-bold">Email</h4>
                                                <p className="mb-1">atendimento@locsolution.com</p>
                                                <p className="text-muted small mb-3">Exclusivo para assistência</p>
                                                <Button
                                                    variant="outline-success"
                                                    className="rounded-pill d-flex align-items-center"
                                                    href="mailto:atendimento@locsolution.com"
                                                >
                                                    Enviar email <FaChevronRight className="ms-2" />
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* FAQ ou Informações Adicionais */}
                <Card className="border-0 shadow-sm bg-light">
                    <Card.Body className="p-4">
                        <Row className="align-items-center">
                            <Col md={8}>
                                <h4 className="fw-bold" style={{ color: verdeEscuro }}>Ainda precisa de ajuda?</h4>
                                <p className="mb-md-0">
                                    Nossa equipe está pronta para ajudá-lo com qualquer problema técnico ou dúvida que você possa ter.
                                </p>
                            </Col>
                            <Col md={4} className="text-md-end mt-3 mt-md-0">
                                <Button
                                    variant="success"
                                    className="rounded-pill px-4 py-2"
                                    style={{ backgroundColor: verdeEscuro, borderColor: verdeEscuro }}
                                    href="https://motomco.com.br/"
                                    target="_blank"
                                >
                                    Visite nosso site
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Container>
        </Page>
    );
};

export default SupportUser;
